import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Heart } from 'lucide-react';
import { NewsletterSubscribe } from '@/components/NewsletterSubscribe';
import { useLocale } from '@/i18n';

const PreviewFooter = () => {
  const t = useLocale();
  return (
    <footer className="bg-[hsl(330,5%,22%)] text-[hsl(30,20%,85%)]">
      {/* Newsletter banner */}
      <div className="bg-[hsl(330,5%,30%)] py-8">
        <div className="px-4 sm:px-6 lg:px-10 text-center">
          <h3 className="font-boho text-2xl text-[hsl(30,20%,90%)] mb-2">
            Join the Boho Family
          </h3>
          <p className="text-[hsl(30,15%,70%)] text-sm mb-4">
            Exclusive access to new arrivals & insider updates
          </p>
          <NewsletterSubscribe
            className="max-w-md mx-auto"
            placeholder="Enter your email"
          />
        </div>
      </div>

      {/* Footer links */}
      <div className="px-4 sm:px-6 lg:px-10 py-10 lg:py-12">
        {/* Brand - centered */}
        <div className="text-center mb-8 lg:mb-10">
          <span className="font-boho text-2xl text-[hsl(30,20%,90%)]">
            Boho Style Co.
          </span>
          <p className="text-[hsl(30,10%,55%)] text-sm mt-3 leading-relaxed max-w-sm mx-auto">
            {t.home.footerTagline}
          </p>
          <div className="flex gap-5 mt-4 justify-center">
            <a href="#" className="text-[hsl(30,10%,55%)] hover:text-berry-light transition-colors p-1">
              <Instagram className="h-5 w-5" />
            </a>
            <a href="#" className="text-[hsl(30,10%,55%)] hover:text-berry-light transition-colors p-1">
              <Facebook className="h-5 w-5" />
            </a>
            <a href="#" className="text-[hsl(30,10%,55%)] hover:text-berry-light transition-colors p-1">
              <Mail className="h-5 w-5" />
            </a>
          </div>
        </div>

        {/* Link columns - centered and adjacent */}
        <div className="grid grid-cols-3 gap-4 sm:flex sm:flex-row sm:gap-16 sm:justify-center">
          {/* Shop */}
          <div>
            <h4 className="text-xs sm:text-sm font-semibold uppercase tracking-wider text-[hsl(30,20%,90%)] mb-3 sm:mb-4">Shop</h4>
            <ul className="space-y-2">
              {[
                { name: 'Apparel', href: '/collections/apparel' },
                { name: 'Dresses', href: '/collections/dresses' },
                { name: 'Footwear', href: '/collections/footwear' },
                { name: 'Jewelry', href: '/collections/jewelry' },
                { name: 'One-Pieces', href: '/collections/one-pieces' },
                { name: 'Lifestyle & Decor', href: '/collections/lifestyle-decor' },
              ].map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-xs sm:text-sm text-[hsl(30,10%,55%)] hover:text-berry-light transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Help */}
          <div>
            <h4 className="text-xs sm:text-sm font-semibold uppercase tracking-wider text-[hsl(30,20%,90%)] mb-3 sm:mb-4">Help</h4>
            <ul className="space-y-2">
              {[
                { name: 'Size Guide', href: '/size-guide' },
                { name: 'Shipping Info', href: '/shipping-info' },
                { name: 'Returns & FAQ', href: '/returns-faq' },
                { name: 'Track My Order', href: '/track-order' },
                { name: 'Privacy Policy', href: '/privacy' },
                { name: 'Contact Us', href: '/contact' },
              ].map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-xs sm:text-sm text-[hsl(30,10%,55%)] hover:text-berry-light transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="text-xs sm:text-sm font-semibold uppercase tracking-wider text-[hsl(30,20%,90%)] mb-3 sm:mb-4">About</h4>
            <ul className="space-y-2">
              {[
                { name: 'Our Story', href: '/about' },
                { name: 'Blog', href: '/blog' },
                { name: 'Slow Living', href: '/slow-living' },
              ].map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-xs sm:text-sm text-[hsl(30,10%,55%)] hover:text-berry-light transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[hsl(330,5%,30%)] py-4">
        <div className="px-4 sm:px-6 lg:px-10 flex flex-col items-center justify-center gap-1 sm:flex-row sm:gap-4 text-xs text-[hsl(30,10%,50%)]">
          <p>© 2026 Boho Style Co. All rights reserved.</p>
          <p className="flex items-center gap-1">
            Curated with <Heart className="h-3 w-3 text-berry" /> in Ruskin, Florida
          </p>
        </div>
      </div>
    </footer>
  );
};

export default PreviewFooter;
